import { useEffect } from 'react';
import { loadCustomTeamLogos } from '../utils/customTeamLogos';

/** Charge les logos d'équipes uploadés par l'admin au démarrage de l'application. */
function CustomTeamLogosLoader() {
  useEffect(() => {
    loadCustomTeamLogos();
  }, []);

  return null;
}

export default CustomTeamLogosLoader;
